import { FormControlLabel } from '@mui/material'
import { CvsRadio } from '../styled-components'
import { Folder } from '../types'
import { createElementIdFromPath } from './helpers'

interface FolderTreeItemLabelProps {
  folder: Folder
  selectedFolder: string
}

export const FolderTreeItemLabel = ({
  folder: { path, label },
  selectedFolder,
}: FolderTreeItemLabelProps) => {
  const currentFolderSplittedPath = path.split('/')
  let folderIsPartOfPath = false
  if (selectedFolder.startsWith(path)) {
    folderIsPartOfPath =
      selectedFolder.split('/')[currentFolderSplittedPath.length - 1] ===
        currentFolderSplittedPath[currentFolderSplittedPath.length - 1] || path === '/'
  }

  return (
    <FormControlLabel
      onClick={event => {
        event.stopPropagation()
        event.preventDefault()
      }}
      id={createElementIdFromPath(path)}
      control={
        <CvsRadio
          value={path}
          semiSelected={folderIsPartOfPath}
          onClick={e => {
            e.stopPropagation()
          }}
        />
      }
      label={<>{label}</>}
      key={path}
    />
  )
}
